
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqtaDCu6IuoZRb5_urqfUHR1Wmhvo0iphq7XhwW4UO5aEMeta } from "/codebuild/output/src2353999609/src/src/pages/faq.vue?macro=true";
import { default as menuJHd4zTaeXANxkiqoVIwPlnO_6mQOeD5pdBEpqr2CnxoMeta } from "/codebuild/output/src2353999609/src/src/pages/menu.vue?macro=true";
import { default as index0VnYYR5002XcIGPG_86onm90Tg7M2YQZYh7Fa_U6HA0Meta } from "/codebuild/output/src2353999609/src/src/pages/index.vue?macro=true";
import { default as contact_VrEKlmnMDcelDCVTOEY8LvFhdkSgQOU2rzmmiyWRE4Meta } from "/codebuild/output/src2353999609/src/src/pages/contact.vue?macro=true";
import { default as tutorial0XwYlp9FT2mA12_45oivkY7dmn3GtZrYUxKI6XDkj8EsEMeta } from "/codebuild/output/src2353999609/src/src/pages/tutorial.vue?macro=true";
import { default as agreement0sh8UtqjkLLiIDKG_457UKeko4v1BFpMEreX3L0lpqwIIMeta } from "/codebuild/output/src2353999609/src/src/pages/agreement.vue?macro=true";
import { default as about_45passztfx3d9Iy7CwxMcJZXSv28dEbUUVXeD3VrLDfHsmZNsMeta } from "/codebuild/output/src2353999609/src/src/pages/about-pass.vue?macro=true";
import { default as indexnkjCrHNl4jZCKuwtab0e1pZXFmcPNEK2ppm5DFDeSzgMeta } from "/codebuild/output/src2353999609/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93txXQxF7rYhp55npBuY7UG0k89eAoQa4ovEhcUVVge2cMeta } from "/codebuild/output/src2353999609/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancerY_HilEhhA7AAhVi_fSP_45xLwbVAVWvTvZoDnbsA1ooYMeta } from "/codebuild/output/src2353999609/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93rN3zHZDQeO1EZIBipc3ggt3ympugLLF2N2iWZ3pITHUMeta } from "/codebuild/output/src2353999609/src/src/pages/notice/[id].vue?macro=true";
import { default as indexmju1h_xH0SvlkfCQBLXJueCtKESRXyTAf633hYtbNQMMeta } from "/codebuild/output/src2353999609/src/src/pages/coupon/index.vue?macro=true";
import { default as index8flwHslcRjsJ1M2h8U8C96ZOiQYHv8R_3gtx1j52ljYMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/index.vue?macro=true";
import { default as index2IU8omEkqp_t1Y1kIcd9gvAHXM9jKp9sPYALBlH05x0Meta } from "/codebuild/output/src2353999609/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_933h11fipBbt7hBFGkH7vFTGcYsgHt03dGkZWcYe_hUDYMeta } from "/codebuild/output/src2353999609/src/src/pages/parking/[id].vue?macro=true";
import { default as indexIkET7___45Jyq0r3yIeuGUOQfJyFTb4eSQAJXSZEflz7kMeta } from "/codebuild/output/src2353999609/src/src/pages/history/index.vue?macro=true";
import { default as indexOLf6EhRYvX99kq_OQgCOfnQRNTbYBWZXtpe7dAcCN_YMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/index.vue?macro=true";
import { default as indexGRTvsnIujpkMiink_452nl3p6Y24JS6rkIxb_eMFrWnwUMeta } from "/codebuild/output/src2353999609/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexGnUCg_UrBmSnXrmcwufhFJambNYye_UKTImqYsXkv8sMeta } from "/codebuild/output/src2353999609/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviEXHxZfWRGMGDGqAkV_45iIuKw_45VSxd_45WrzjarSPMKgwOYMeta } from "/codebuild/output/src2353999609/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editO843zgDgb2TfSOlp1PHf7mtvWTIbK9HyYDNnlORLf0sMeta } from "/codebuild/output/src2353999609/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementqXuQV0sn6pHEtz7x2FbzeoAyJSJllkr33es2gyXc_ssMeta } from "/codebuild/output/src2353999609/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexojR4WGi_45T3PxGIIwZio1Y8vUdZkzTwW9W2q6ydAmdW8Meta } from "/codebuild/output/src2353999609/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dv_45OnNPdce70C83KtUXjVK3Evf5duSWWtsAXNgGucWwQMeta } from "/codebuild/output/src2353999609/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmxnviLwSwkGuh_45y2sDZevmDXlHUuttLfRzZMEA_45TR9YMMeta } from "/codebuild/output/src2353999609/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index03AIqHTONFvKZsSiKXp4T9ue8IQit_45cVDd31DGjTkA4Meta } from "/codebuild/output/src2353999609/src/src/pages/card/create/index.vue?macro=true";
import { default as indexlZL3lWJzrxENIT1KnLP0Y5Qa2BbOPEFdj9Fs8WJyF9IMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm9AiDDCNC0_y_8U_45JKd7nH7_459NFC4ZjAcmtyiRW4a8wgMeta } from "/codebuild/output/src2353999609/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmPH0c_ml1aFCK_45Jp1zIu8YTecqiiDaReqJYrIM491DpsMeta } from "/codebuild/output/src2353999609/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete0f4gNFCD1Jt_Q3wwuSMlfi9LHiunx5m5T6OTLbJ5rsEMeta } from "/codebuild/output/src2353999609/src/src/pages/membership/complete.vue?macro=true";
import { default as registeruBueab_InPHt6_45Y8NFSoc8IB51c_XHIsVbXGdUnwmXwMeta } from "/codebuild/output/src2353999609/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93ZT9yB5SNeXyw8K36Vhr9SupewajYRdYoUSUz_KEbmaUMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmrflEmz6QggHDo0ih14mXz4Wpf_45kuUXQr5OwoQx1EsngMeta } from "/codebuild/output/src2353999609/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93Gvzn2b5ms4vOntjP3yzu8hUD9_jM1YWLYH5bCbUE0kIMeta } from "/codebuild/output/src2353999609/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexYxEFkLfacmse2Yv5E8R1bbhNO0v8ltGwg8zyGbR8owQMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code9eK1ItRtSR0AsC3qBUqv008JmLrjTNumr1q1EyDay6oMeta } from "/codebuild/output/src2353999609/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codel2UhUJXDTiLiJ5xAln8eHI9yNB85f2O_45snLh4Pt906sMeta } from "/codebuild/output/src2353999609/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeF9roE_457jKzTn6rIXKiZNZSOF0IYf0M3ppgZsy_45gpe4wMeta } from "/codebuild/output/src2353999609/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registern4y_XPvc_3DrNYmESYAzpmPr1MxFp6mkDsihLbsjFBIMeta } from "/codebuild/output/src2353999609/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeD595psDyS4tYjSyJPYONNFQnSML1tpGJfxKu4zTpc0cMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexjc5lTpMZ2DxQyW_kx6bEuyJ60iGMBOduKvdVNc0nfsQMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm87U14xGFE2YAvOUYv6vGbM6n2MQ1zEPgpKOOrzW8ILYMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completedAD856AWaFRmh6tVcxsFI4EyZQiVpVrEgovx44pomvkMeta } from "/codebuild/output/src2353999609/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexWeN4pdcKZZh62Zn1zczEaBsQPe_45frdO2L16COn4h4JIMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93VH3ViXDQH_WAU86YQl8f1umNqGuTehTg3dGLAXehzDMMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeXBU5uECw2yDyy_452kmwMumFtSDKfbdlOv5WoJIHvNpOUMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasdQMiAB149ALOqiGRil4sdIg2C7ocBZZ3obsuY3cCL_45YMeta } from "/codebuild/output/src2353999609/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleZHhYyunTN0uG3VFcHQtW2y0GX9clrQ2y0CZSJPPw_45e8Meta } from "/codebuild/output/src2353999609/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailTH9S2A5usSgzjwG7UvE9846eHDFeb_6tCyE_NpjOCOgMeta } from "/codebuild/output/src2353999609/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmNgJaLRYbuew2N3zv4HhA_9b7znrxlq2zkbnKYr20AYoMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent3JLcjNZA5i8lE76f2eKDLMEbpJQ5Dk0DVCa41FrcSWcMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm_HmTdr_45lHhc9eyR60FJDmFTw7emKbrfmXmjvRkpKYtAMeta } from "/codebuild/output/src2353999609/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateLouWYwO8ULE06GzHRkiQEZD3q0hEIQv73fVSLT8nXiIMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeE1BgVR8vRvUNqjpIlOtaaLgYtfu6YpVnBFS11vwm1woMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeLvt2cPESTfIhpCx4Tan3tkWFkGNORdGtb2mMh1uin7UMeta } from "/codebuild/output/src2353999609/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordSYc8WjXhPI6uFamkl5MeT6QPvsdiQyZBBsjWfKlEvAcMeta } from "/codebuild/output/src2353999609/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias8rfW6h3t1svIgA0zSXN9VNvQSiFZ6VDn_45MQkxFP7N3QMeta } from "/codebuild/output/src2353999609/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registeri8hpA3c5V_45J0VVSewjOuuVDtJKcdSy0mXlL36WHryrUMeta } from "/codebuild/output/src2353999609/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codel2dRYSRKzPropC4SObkG78aInYsrQ6GBYkvsWFVTj_MMeta } from "/codebuild/output/src2353999609/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexdUu_45_45M8BGkDxs86RJLC35vR3YlMIK_h0EygwbXc_Zp8Meta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index4zHhzkSmXdmwECLDv8xANDGmTXPhYchUtZj4eksYL64Meta } from "/codebuild/output/src2353999609/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexdVpFCifJJ9SjjsEAlEYqv7T3iZu6amIvPrHEFHglo2sMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexdrDAYO3eqt5N1ndUvBY2PovTun6zLFggW8r0jN_451kVEMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatexrERRLvJMGE1O2pxnNgTv9k7UaWfUTDwqbIGQDvhMEkMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completePyyBWqT0KegRYJpQ0YvRgUDyjsfLtvQ9kYLkyBnNgFcMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmdtcClUdyM9FsW8k6Vkv7tDJC0h5LhjVjl_45NCcuvUYPEMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexV_45dj8vtCzVnkWoXV_45mCucTasfwlZpN4iJc01IUludgYMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completechs7oz3aU_qk0UZvldYQwR0T_1GnD7MxCNUGXO_451MzIMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatekTK6MYP1PBlNOwNwU2uGjNsHQgv0T4z8wowJMgN7MPAMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexIQO9LFQ_Ff1TlipXESEW_45rJPGHqpkHdWt_8VVlxOmZgMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexmNE6uubWKMxrBCOdqVkqNkxZq8lTmTGDyYWiytG_3N8Meta } from "/codebuild/output/src2353999609/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completewjpvsUJHW5ek0o_45dqLwETGg81tzHWX0vEqSGQdy1sVoMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index0Wd9eairS4x_45Xxk8wn5uZaQa31RoloMD1sZLOyWXHaQMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeAPt3OSX9jmxCG8zvcT7bJI7s_eiIDdvb8zOeGKhwi7cMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexwgqdfAiBSpp0ZpRyS_45YDyQXbg3UXJuMQI3ETUpx2J5cMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexHx8rSg4HkQJjUKB_YkhYBmDJmBPbQS3NTk7sllYtpFUMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexfK5ljWkGQDX3zqO50XIok2LwTv_n3crEm9lOr_45hexeYMeta } from "/codebuild/output/src2353999609/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatehNXM8MFtWmO3aq2d_45MhcltoHIajQx3O1m25_CrrDm7oMeta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmJXp_htd11zHae6v49IiB_9a0ZYwWJ9775JqU6RMhNE4Meta } from "/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuJHd4zTaeXANxkiqoVIwPlnO_6mQOeD5pdBEpqr2CnxoMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index0VnYYR5002XcIGPG_86onm90Tg7M2YQZYh7Fa_U6HA0Meta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexmju1h_xH0SvlkfCQBLXJueCtKESRXyTAf633hYtbNQMMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexIkET7___45Jyq0r3yIeuGUOQfJyFTb4eSQAJXSZEflz7kMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexGRTvsnIujpkMiink_452nl3p6Y24JS6rkIxb_eMFrWnwUMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexGnUCg_UrBmSnXrmcwufhFJambNYye_UKTImqYsXkv8sMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index03AIqHTONFvKZsSiKXp4T9ue8IQit_45cVDd31DGjTkA4Meta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm9AiDDCNC0_y_8U_45JKd7nH7_459NFC4ZjAcmtyiRW4a8wgMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmPH0c_ml1aFCK_45Jp1zIu8YTecqiiDaReqJYrIM491DpsMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete0f4gNFCD1Jt_Q3wwuSMlfi9LHiunx5m5T6OTLbJ5rsEMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registeruBueab_InPHt6_45Y8NFSoc8IB51c_XHIsVbXGdUnwmXwMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmrflEmz6QggHDo0ih14mXz4Wpf_45kuUXQr5OwoQx1EsngMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code9eK1ItRtSR0AsC3qBUqv008JmLrjTNumr1q1EyDay6oMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codel2UhUJXDTiLiJ5xAln8eHI9yNB85f2O_45snLh4Pt906sMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeF9roE_457jKzTn6rIXKiZNZSOF0IYf0M3ppgZsy_45gpe4wMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registern4y_XPvc_3DrNYmESYAzpmPr1MxFp6mkDsihLbsjFBIMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm87U14xGFE2YAvOUYv6vGbM6n2MQ1zEPgpKOOrzW8ILYMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completedAD856AWaFRmh6tVcxsFI4EyZQiVpVrEgovx44pomvkMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexWeN4pdcKZZh62Zn1zczEaBsQPe_45frdO2L16COn4h4JIMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeXBU5uECw2yDyy_452kmwMumFtSDKfbdlOv5WoJIHvNpOUMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleZHhYyunTN0uG3VFcHQtW2y0GX9clrQ2y0CZSJPPw_45e8Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailTH9S2A5usSgzjwG7UvE9846eHDFeb_6tCyE_NpjOCOgMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmNgJaLRYbuew2N3zv4HhA_9b7znrxlq2zkbnKYr20AYoMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent3JLcjNZA5i8lE76f2eKDLMEbpJQ5Dk0DVCa41FrcSWcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm_HmTdr_45lHhc9eyR60FJDmFTw7emKbrfmXmjvRkpKYtAMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeE1BgVR8vRvUNqjpIlOtaaLgYtfu6YpVnBFS11vwm1woMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeLvt2cPESTfIhpCx4Tan3tkWFkGNORdGtb2mMh1uin7UMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordSYc8WjXhPI6uFamkl5MeT6QPvsdiQyZBBsjWfKlEvAcMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registeri8hpA3c5V_45J0VVSewjOuuVDtJKcdSy0mXlL36WHryrUMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codel2dRYSRKzPropC4SObkG78aInYsrQ6GBYkvsWFVTj_MMeta || {},
    component: () => import("/codebuild/output/src2353999609/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2353999609/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]